import payment from "@/plugins/api/factories/Payment";

export const state = {
  paymentResponse: null,
  cardSaveResultMessage: null,
  paymentData: {
    amount: null,
    app_id: process.env.VUE_APP_EASYPAY_APP_ID,
    ls: null,
    save_card: false,
    card_token: null,
  },
  cards: [],
  paymentUrl: null,
  addCardUrl: null,
};

export const actions = {
  async getPaymentPage({ commit, state }) {
    return await payment.getPaymentUrl(state.paymentData, async (response) => {
      commit("SET_PAYMENT_URL", response.url);
      commit("SET_PAYMENT_RESPONSE", response);
    });
  },
  async getClusterPaymentPage({ commit }, payload) {
    return await payment.getClusterPayment(payload, async (response) => {
      commit("SET_PAYMENT_URL", response.url ? response.url : null);
      commit("SET_PAYMENT_RESPONSE", response);
    });
  },
  async saveCard({ commit }, payload) {
    return await payment.saveCard(payload, async (response) => {
      commit(
        "SET_PAYMENT_URL",
        response.redirect_url || response.url ? response.redirect_url || response.url : null
      );
      commit("SET_PAYMENT_RESPONSE", response);
      return response;
    });
  },
  async getCardsList({ commit }) {
    await payment.getEasyPayCardsList((response) => {
      commit("SET_PAYMENT_CARDS", response.cards ? response.cards : []);
    });
  },
  async deleteCard(store, cardToken) {
    return await payment.deleteCard({ card_token: cardToken }, (res) => {
      return res;
    });
  },
  async getSaveCardPage({ commit }) {
    await payment.getEasyPaySaveCardsPage((response) => {
      commit("SET_ADD_CARD_URL", response.url);
    });
  },
};

export const mutations = {
  SET_PAYMENT_RESPONSE(state, response) {
    state.paymentResponse = response;
  },
  SET_CARD_SAVE_RESULT_MESSAGE(state, message) {
    state.cardSaveResultMessage = message;
  },
  SET_PAYMENT_CARDS(state, cards) {
    state.cards = cards;
  },
  SET_CARD_TOKEN(state, token) {
    state.paymentData.card_token = token;
  },
  SET_SAVE_CARD(state, type) {
    state.paymentData.save_card = type;
  },
  SET_PAYMENT_URL(state, url) {
    state.paymentUrl = url;
  },
  UPDATE_AMOUNT(state, amount) {
    if (amount === null || amount === undefined || amount === "") {
      state.paymentData.amount = null;
      return;
    }

    const normalizedAmount = Number(amount);
    state.paymentData.amount =
      Number.isFinite(normalizedAmount) && normalizedAmount > 0
        ? normalizedAmount
        : null;
  },
  SET_USER_LS(state, ls) {
    state.paymentData.ls = ls;
  },
  SET_ADD_CARD_URL(state, url) {
    state.addCardUrl = url;
    console.log("CHLENIX SET_ADD_CARD_URL: " + JSON.stringify(state.addCardUrl));
  },
};
